import React from "react";
import OldQrcodeTemplate from "@/components/templates/verifies/OldQrcodeTemplate";

const OldPisenView: React.FC = () => {
  return <OldQrcodeTemplate oldQrcode="pisen" />;
};

export default OldPisenView;
